// extracted by mini-css-extract-plugin
export default {"container":"style_container__4-3yI","imageWrapper":"style_imageWrapper__UfptD","closeButton":"style_closeButton__dHZo+"};